module.exports = new __parcel__URL__("mythical_pack_icon.86948a51.png").toString();